import { Image } from 'antd';
import React from 'react';

interface ScreenFrameProps {
  image: string;
  position: 'left' | 'mid' | 'right';
}

const ScreenFrame: React.FC<ScreenFrameProps> = ({ image, position }) => {
  return (
    <div className={`outer-frame ${position}`}>
      <div className="frame">
        <Image width="100%" src={image} />
      </div>
    </div>
  );
};

export default ScreenFrame;
